import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import variables from '@chama/statics/stylesheets/variables';
import * as icons from './icons';

import './Icon.css';

const createIcon = ({ type, color }) => {
  const iconFn = icons[type];
  if (typeof iconFn !== 'function') {
    throw new Error(`Icon with name: ${type} does not exist`);
  }
  return iconFn(color);
};

export default function Icon({
  className,
  onClick,
  type,
  width,
  height,
  padding,
  borderRadius,
  iconColor,
  backgroundColor,
  ...rest
}) {
  const styles = {
    width: `${width}px`,
    height: `${height}px`,
    padding: `${padding}px`,
    backgroundColor,
    borderRadius: `${borderRadius}px`,
  };

  return (
    <i className={classnames('Icon', className)} style={styles} onClick={onClick} {...rest}>
      {createIcon({ type, color: iconColor })}
    </i>
  );
}
Icon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  padding: PropTypes.number,
  borderRadius: PropTypes.number,
  iconColor: PropTypes.string,
  backgroundColor: PropTypes.string,
};
Icon.defaultProps = {
  className: '',
  onClick: Function.prototype,
  width: 24,
  height: 24,
  padding: 0,
  backgroundColor: 'transparent',
  borderRadius: 4,
  iconColor: variables.default['--chama-blue'],
};



// WEBPACK FOOTER //
// ../ui-components/components/Icon/Icon.jsx